import { combineReducers } from 'redux';

import discrepancy from './discrepancy/reducer';
import demand_aggregator from './demand_aggregator/reducer';

export default combineReducers({
  discrepancy,
  demand_aggregator
});
